/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_General_Show_Rona_PopupInputs */

const en_forms_teams_settings_general_show_rona_popup = /** @type {(inputs: Forms_Teams_Settings_General_Show_Rona_PopupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rona Popup`)
};

const de_forms_teams_settings_general_show_rona_popup = /** @type {(inputs: Forms_Teams_Settings_General_Show_Rona_PopupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RONA-Popup anzeigen`)
};

/**
* | output |
* | --- |
* | "Rona Popup" |
*
* @param {Forms_Teams_Settings_General_Show_Rona_PopupInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_general_show_rona_popup = /** @type {((inputs?: Forms_Teams_Settings_General_Show_Rona_PopupInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_General_Show_Rona_PopupInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_general_show_rona_popup(inputs)
	return de_forms_teams_settings_general_show_rona_popup(inputs)
});